import React from "react";
import './RugGrid.css';

function RugGrid({ grid, toggleSquare }) {
  // Count selected squares
  const selectedSquares = grid.flat().filter((sq) => sq).length;
  const area = selectedSquares * 1; // Assuming each square is 1x1'.

  const handleSquareToggle = (rowIndex, colIndex) => {
    // Only allow toggling a square off if more than one square is selected
    if (selectedSquares === 1 && grid[rowIndex][colIndex]) {
      return;
    }
    toggleSquare(rowIndex, colIndex);
  };

  return (
    <div className="rug-grid-container">
      <div className="grid-description">
        <h2 className="grid-title">How the Rug Grid Works</h2>
        <p className="grid-text">
          The grid represents a 6x4' area, with each square being 1x1'. Click on the individual squares below to select them. Each selected square represents a part of your custom rug. 
        </p>
      </div>
      <div className="rug-area">
        <p className="area-text">Total Area: {area} sq.ft.</p>
      </div>
      <div className="grid">
        {grid.map((row, rowIndex) =>
          row.map((isSelected, colIndex) => (
            <div
              key={`${rowIndex}-${colIndex}`}
              className={`square ${isSelected ? "selected" : ""}`}
              onClick={() => handleSquareToggle(rowIndex, colIndex)}
            />
          ))
        )}
      </div>
    </div>
  );
}

export default RugGrid;
